/* Section initialization is idempotent, including Shopify editor reloads. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root = document) {
    root.querySelectorAll('[data-video-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const video = button.closest('.lb-hero').querySelector('video');
      if (!video) { button.hidden = true; return; }
      const update = () => {
        button.textContent = video.paused ? '▷' : 'Ⅱ';
        button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      };
      if (reducedMotion.matches) { video.autoplay = false; video.pause(); }
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update); else video.pause();
      });
      update();
    });
    root.querySelectorAll('[data-lb-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.lb-social__track');
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const position = gallery.querySelector('.lb-gallery-position');
      const move = direction => track.scrollBy({left: direction * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      const update = () => {
        const width = track.clientWidth || 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + width >= track.scrollWidth - 2;
        position.textContent = `${Math.round(track.scrollLeft / width) + 1} / ${Math.ceil(track.scrollWidth / width)}`;
      };
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
